import Fuse from 'fuse.js';
import { StoredNotification } from '../model/StoredNotification';

export function clamp(num: number, min: number, max: number): number {
  return num <= min ? min : num >= max ? max : num;
}

export function checkTolerance(tolerance: number, value: number, target: number): boolean {
  const withinMin = value < target + tolerance;
  const withinMax = value > target - tolerance;
  return withinMin && withinMax;
}

/**
 * Typeguard filter against `StoredNotification`'s and `Fuse` results
 */
export function isStoredNotification(
  data: StoredNotification | Fuse.FuseResult<StoredNotification>
): data is StoredNotification {
  return !!(data as StoredNotification).notification;
}

export * from './Hydrate';
